const DATA_DA_TRANSICAO = Date.parse('2026-12-16T00:00:00-03:00')
const MILISSEGUNDOS_POR_DIA = 24 * 60 * 60 * 1000

export function calcularDiasParaTransicao(agora = Date.now()): number {
  return Math.max(0, Math.ceil((DATA_DA_TRANSICAO - agora) / MILISSEGUNDOS_POR_DIA))
}
